
<!-- Main Page Start -->
<section class="pd-tb completeProfile">
    <div class="container">
        <form  [formGroup]="form">
        <div class="topHeader">
            <h2 class="mainTitle"> Edit Profile</h2> 
        </div>

        <div class="profileInfo mb-5">
            <div class="profile-upload ">
                <div class="proEdit">
                    <input type="file" accept=".png, .jpg, .jpeg" #myInput (change)="upload($event)">
                    <label id="imageUpload"><i class="ic_profile_edit"><img src="assets/images/ic_profile_edit.svg"></i></label>
                </div>
                <div class="avatar-preview">
                    <div id="imagePreview">
                        <img [src]="imageUpload != null || imageUpload == '' ? globalUrl + imageUpload : '../../../assets/images/profile-img.jpg'" alt="profile">
                    </div>
                </div>
                <!-- <div class="text-danger" *ngIf="dummyImage == null && showError">
                    *Please enter profile Image.
                </div> -->
            </div> 
            <div class="profileName">
                <h5 class="name">{{userData?.name}} </h5>
                <p class="email">{{userData?.email}} </p>
                <div class="d-flex spaceRight radioWrap">
                    <input type="radio" id="she" value="She/Her" name="pronounsType" formControlName="pronounsType" (click)="onSelectCustom($event)">
                    <label for="she"> She/Her </label>

                    <input type="radio" id="he"  value="He/Him" name="pronounsType" formControlName="pronounsType" (click)="onSelectCustom($event)">
                    <label for="he"> He/Him </label>

                    <input type="radio" id="they" value="They/Them" name="pronounsType" formControlName="pronounsType" (click)="onSelectCustom($event)">
                    <label for="they"> They/Them </label>

                    <input type="radio" id="addc"  value="Add custom" name="pronounsType" formControlName="pronounsType" (click)="onSelectCustom($event)">
                    <label for="addc"> Add custom </label>
                </div>
                <div class="text-danger" *ngIf="form.controls['pronounsType'].hasError('required') && showError">
                    *Please enter pronouns type.
                </div>

                <div class="row" *ngIf="form.controls['pronounsType'].value == 'Add custom' ">
                    <div class="col-lg-8 col-md-8 col-sm-12">
                        <div class="form-group">
                            <input type="text" class="form-control" name="" placeholder="Enter" formControlName="customPronouns"  maxlength="30"  (change)="onInputCustom($event)">
                        </div>
                        <div class="text-danger" *ngIf="form.controls['customPronouns'].hasError('required') && showError">
                            *Please enter custom.
                        </div>
                    </div>
                </div>    
            </div>
         </div>

        <div class="personal-info">
             <h5 class="subTitle"> Personal Info </h5>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="form-group">
                            <label> Phone Number </label> 
                            <div  class="countryCode">
                                <span>(+1)</span>
                                <input type="text" class="form-control" name="" placeholder=" 1234567890" formControlName="phoneNumber"  (keypress)="preventNumbers($event)"  maxlength="10" [(ngModel)]="phoneVerified" [readonly]="isReadonly" >
                                <!--id="phone-number"  appPhoneMask -->
                                <img src="../../../../assets/images/ic_verified.svg" *ngIf="title == 'Change'" class="greeTick">
                                <button class="otpButton" (click)="title != 'Change' ?  verifyPhone(otpVerify,form.value.phoneNumber) : change(form.value.phoneNumber)">{{title}}</button>
                            </div>
                            <div class="text-danger" *ngIf="showErrorPhoneNo">
                                *Please enter phone number.
                            </div>
                            <div class="text-danger" *ngIf="form.controls['phoneNumber'].hasError('required') && showError">
                                *Please enter phone number.
                            </div>
                            <div class="text-danger" *ngIf="form.controls['phoneNumber'].hasError('maxLength') && showError">
                                *Maximum Length of phone number is 10.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="form-group">
                            <label> Date of Birth<span class="orangeText">*</span></label>
                            <div id="date-picker-example" class="datepicker"> 
                                <input type="text" placeholder="Select date" class="form-control" bsDatepicker formControlName="dateOfBirth" [bsValue]="form.value.dateOfBirth" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" [maxDate]="maxDate">
                                 <img src="assets/images/ic_calendar.svg" alt="calender">
                             </div>   
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="form-group">
                            <label> Gender<span class="orangeText">*</span></label>
                            <div class="d-flex spaceRight radioWrap pt-3">
                                <input type="radio" value="0" name="gender" formControlName="gender" id="male" [checked]="form.value.gender === '0'" (change)="onChange($event)">
                                <label for="male"> Male</label>
                                <input type="radio" id="female" value="1" name="gender" formControlName="gender" [checked]="form.value.gender ==1" (change)="onChange($event)">
                                <label for="female"> Female </label>
                                <input type="radio" id="Non-binary" value="2" name="gender" formControlName="gender" [checked]="form.value.gender==2" (change)="onChange($event)"> 
                                <label for="Non-binary"> Non-binary </label>
                            </div>
                            <div class="text-danger" *ngIf="form.controls['gender'].hasError('required') && showError">
                                *Please select gender.
                            </div>

                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="form-group">
                            <label>Are you service-disabled?<span class="orangeText">*</span></label>
                            <div class="d-flex spaceRight radioWrap">
                                <input type="radio" id="yes"  [value]="1" name="serviceDisabled" formControlName="serviceDisabled"[(ngModel)]="actionUpload">
                                <label for="yes"> Yes </label>
                                <input type="radio" id="no"  [value]="2" name="serviceDisabled" formControlName="serviceDisabled" [(ngModel)]="actionUpload">
                                <label for="no"> No </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="form-group">
                            <label> Bio<span class="orangeText">*</span></label>
                            <textarea type="text" class="form-control" placeholder="This article is about ground-warfare militaries. For the large military formation, see field army." formControlName="bio" maxlength="250"></textarea>
                            <div class="text-danger" *ngIf="form.controls['bio'].hasError('required') && showError">
                                *Please Enter Bio.
                            </div>
                            <div class="text-danger" *ngIf="form.controls['bio'].hasError('maxlength') && showError">
                                *Minimum length of 250 characters.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="form-group">
                            <label>Honors and Awards </label>
                            <div class="p-relative">
                                <input type="text" class="form-control" placeholder="Enter"  #hAwards>
                                <a href="javascript:void(0);" class="addMore" (click)="addMore(hAwards, hAwards.value)"><img src="../../../../assets/images/add-circle.svg"/></a>
                            </div>
                            <div class="text-danger" *ngIf="form.controls['honorAwardArray'].hasError('required') && showError">
                                *Please enter Honor and Awards.
                            </div>
                        </div>
                    </div>
                
                <div class="col-lg-4 col-md-4 col-sm-12 mb-2" *ngFor="let awards of awardList;let i=index" >
                <div class="joinservice"><span> {{awards?.name}}</span><a  href="javascript:void(0)" (click)="deleteLanguage(awards)" title="Delete"><img src="assets/images/ic_delete.svg"> </a></div>
                  </div> 
                   
                <!-- <div class="col-sm-12 col-lg-12 col-md-12">
                <div class="bluebox">
                    <p> Speed up profile creation </p>
                    <div class="fetchBtn"><img src="assets/images/ic_LinkedIn.svg"> Fetch from Linkedin </div>
                </div>
            </div> -->
            </div>
            <!-- Personality div -->
            <h5 class="subTitle">My Personalities</h5>
        
            <div class="row align-items-center">
           
            <div class=" col-lg-6 col-sm-12 col-md-6 addressWrap">                      
                <div class="detectLocation"><span class="blue">16personalities.com </span><a href="https://www.16personalities.com/" class="allowBtn" target="_blank"> Take Test Now</a></div>
                
            </div>
             <div class="col-lg-6 col-sm-12 col-md-6 addressWrap">
                <div class="form-group">
                    <label> Score Link</label>
                    <input type="text" class="form-control" name="" placeholder="https://www.16personalities.com/esfp" formControlName="scoreLink">
                    <div class="text-danger" *ngIf="form.controls['scoreLink'].hasError('required') && showError">
                        *Please enter score link.
                    </div>
                    <div class="text-danger" *ngIf="form.controls['scoreLink'].hasError('pattern') && showError">
                        *Please enter Valid score link with https eg.(https://www.16personalities.com).
                    </div>
                    <div class="text-danger" *ngIf="showErrorUrlNotMatch">
                        *Please enter Valid score link with https eg.(https://www.16personalities.com).
                    </div>
                </div>
            </div>
          </div>
            <!-- end -->

    
            <div class="row">
                <div class="col-sm-12 col-lg-6 col-md-6 pt-4">
                    <div class="addressWrap">
                        <h5 class="subTitle"> Address Info </h5>
                        <div class="detectLocation"> Detect my current location  <a href="javascript:void(0);" class="allowBtn" (click)="openModal(allowGeo)"> Allow </a></div>
                    </div>

                    <div class="enterManually"><span> Or, enter manually </span></div>
                </div>
            </div>
                
                    <div class="row">
                        <div class="col-md-6 col-sm-12 col-lg-6">
                            <div class="form-group">
                                <label> Location <span class="orangeText">*</span></label>
                                <textarea type="text" class="form-control" name="" placeholder=" Cr 92 No. 34E-112, Medellín " formControlName="location"
                                    ngx-google-places-autocomplete (onAddressChange)="onAddressChange($event)"></textarea>
                                <div class="text-danger" *ngIf="form.controls['location'].hasError('required') && showError">
                                    *Please enter location.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 clo-sm-12 col-lg-6">
                            <div class="form-group">
                                <label> Zipcode </label>
                                <input type="text" class="form-control" name="" placeholder="76001" formControlName="zipCode" (keypress)="preventNumbers($event)" maxlength="6">
                                <div class="text-danger" *ngIf="form.controls['zipCode'].hasError('required') && showError">
                                    *Please enter zipCode.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="form-group">
                                <input type="submit" class="commonBtn mt-5" value="Save &amp; Continue"  (click)="onSubmit()">
                                <!-- <a href="upload-document-family.html" class="commonBtn mt-5"> Save &amp; Continue </a> -->
                            </div>
                        </div>
                    </div>
        </div>
    </form>
    </div>
</section>

<div class="modal cropperModal" role="dialog" *ngIf="show">
    <div class="modal-dialog  cropperBox" role="document">
        <div class="modal-content">
            <div class="modal-header border-bottom-0 ">
                <div class="form-title">
                    <h2 class="mainTitle text-center">Image Cropper</h2>
                </div>
                <!-- <button type="button cursorHandPoint" class="close " (click)="close()" data-dismiss="modal " aria-label="Close ">&times;</button> -->
            </div>
            <div class="modal-body">
                <app-common-upload [objectProperty]="objectProp" (valueChange)='catchFile($event)'
                    (changeDetected)="onChangeDetected($event)"></app-common-upload>
               
            </div>
        </div>
    </div>
</div>
<ng-template #allowGeo>
    <div class="modal-body text-center">
      <form>
       <h3 class="pageTitle ">Allow us to access your location.</h3>
       <p >We need your location to provide you with the best experience Your location is safe with us.</p>
  
        <div class="form-group  mt-4">
            <ul class="list text-center">   
                <a class="addMoreBtn greyBtn" href="javascript:void(0);" (click)="closeModal()">Cancel</a>                                
                <a class="orangeBtn" href="javascript:void(0);" (click)="getLocation()">Allow location</a>
                                    
             </ul>
        </div>
    </form>
    </div>
  </ng-template>
<ng-template #otpVerify>
    <div class="modal-body">
      <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">&times;</button>
      <h4 class="pageTitle" sytle="text-align:center !important; display:block !important;">Verification Code</h4>
      <p>We have sent  the code of verificaiton to your mobile number.</p>
      <!-- <form [formGroup]="otpForm">  -->
        <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" *ngIf="showOtpComponent" [config]="config"  (keypress)="preventNumbers($event)"></ng-otp-input>
        <div class="text-danger" *ngIf="showErrorOtp">
          *Please enter otp.
      </div> 
      <p> Sending OTP in <span class="orangeText" id="timer"> {{display}} </span></p>
      <p> Didn’t receive the code? <a  href="javascript:void(0);" class="orangeText" (click)="resendOTP()"> Resend </a> </p>
        <div class="form-group">
          <!-- <input type="button" value="Verify" (click)="verify()" class="commonBtn mt-5">  -->
          <a (click)="verify()" class="commonBtn mt-5"> Verify</a>
        </div>
    <!-- </form> -->
    </div>
</ng-template>